// extracted by mini-css-extract-plugin
export default {"header":"Header_header__f2lGE","expandIcon":"Header_expandIcon__tJFjh"};